import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HNeventSetRedirectTo, HNeventSetRedirectToUrlAfterLogin } from '@helsenorge/framework-utils/web-component/events';
const Personvelger = ({ redirectTo, redirectToUrlAfterLogin }) => {
    const [webcompIsReady, setWebcompIsReady] = useState(false);
    const location = useLocation();
    useEffect(() => {
        setWebcompIsReady(true);
    }, []);
    useEffect(() => {
        if (webcompIsReady) {
            if (redirectTo) {
                HNeventSetRedirectTo(redirectTo);
            }
            if (redirectToUrlAfterLogin) {
                HNeventSetRedirectToUrlAfterLogin(redirectToUrlAfterLogin);
            }
        }
    }, [redirectTo, redirectToUrlAfterLogin, history, location, webcompIsReady]);
    return _jsx("hn-webcomp-personvelger", {});
};
export default Personvelger;
